module.exports = __webpack_public_path__ + "static/media/Bako.f28a519c.png";